import React from 'react';
import {
  Box, Heading, Divider, Checkbox, Select, Slider, SliderTrack, SliderFilledTrack, SliderThumb,
  Button, Stack, Text, HStack, IconButton, SimpleGrid, useColorModeValue, RangeSlider, RangeSliderTrack, RangeSliderFilledTrack, RangeSliderThumb
} from '@chakra-ui/react';
import { AddIcon, MinusIcon } from '@chakra-ui/icons';

const JobOpeningFilter = ({
  location, setLocation, allLocations,
  types, setTypes, allTypes,
  experiences, setExperiences, allExperiences,
  minSalary, maxSalary, setSalaryRange,
  salaryPeriod, setSalaryPeriod, allPeriods
}) => {
  const sectionBg = useColorModeValue('green.50', 'green.900');

  const handleTypeChange = (type) => {
    setTypes(types.includes(type) ? types.filter(t => t !== type) : [...types, type]);
  };
  const handleExperienceChange = (exp) => {
    setExperiences(experiences.includes(exp) ? experiences.filter(e => e !== exp) : [...experiences, exp]);
  };

  return (
    <Box bg={sectionBg} borderRadius="xl" boxShadow="sm" p={{ base: 2, md: 4 }} w="full" overflow="hidden">
      <Heading as="h3" size="md" mb={4} fontWeight="semibold" fontSize={{ base: 'md', md: 'lg' }}>Filter By</Heading>

      {/* Location */}
      <Box bg={sectionBg} borderRadius="lg" p={{ base: 2, md: 4 }} mb={4} w="full">
        <HStack justify="space-between" mb={2}>
          <Text fontWeight="bold" fontSize={{ base: 'sm', md: 'md' }}>Location</Text>
          <IconButton icon={<MinusIcon />} size="xs" variant="ghost" aria-label="Collapse" />
        </HStack>
        <Select size="sm" mb={2} value={location} onChange={e => setLocation(e.target.value)} w="full" fontSize={{ base: 'sm', md: 'md' }}>
          <option value="">All Locations</option>
          {allLocations.map(loc => <option key={loc} value={loc}>{loc}</option>)}
        </Select>
      </Box>
      <Divider mb={4} />

      {/* Job Type */}
      <Box bg={sectionBg} borderRadius="lg" p={{ base: 2, md: 4 }} mb={4} w="full">
        <HStack justify="space-between" mb={2}>
          <Text fontWeight="bold" fontSize={{ base: 'sm', md: 'md' }}>Job Type</Text>
          <IconButton icon={<MinusIcon />} size="xs" variant="ghost" aria-label="Collapse" />
        </HStack>
        <Stack spacing={1} w="full">
          {allTypes.map(type => (
            <HStack justify="space-between" key={type} w="full">
              <Checkbox size="sm" isChecked={types.includes(type)} onChange={() => handleTypeChange(type)} fontSize={{ base: 'sm', md: 'md' }}>{type}</Checkbox>
              <Text fontSize="xs" color="gray.500">{/* count placeholder */}</Text>
            </HStack>
          ))}
        </Stack>
      </Box>
      <Divider mb={4} />

      {/* Experience */}
      {/* <Box bg={sectionBg} borderRadius="lg" p={{ base: 2, md: 4 }} mb={4} w="full">
        <HStack justify="space-between" mb={2}>
          <Text fontWeight="bold" fontSize={{ base: 'sm', md: 'md' }}>Experience</Text>
          <IconButton icon={<MinusIcon />} size="xs" variant="ghost" aria-label="Collapse" />
        </HStack>
        <Stack spacing={1} w="full">
          {allExperiences.map(exp => (
            <HStack justify="space-between" key={exp} w="full">
              <Checkbox size="sm" isChecked={experiences.includes(exp)} onChange={() => handleExperienceChange(exp)} fontSize={{ base: 'sm', md: 'md' }}>{exp}</Checkbox>
              <Text fontSize="xs" color="gray.500"></Text>
            </HStack>
          ))}
        </Stack>
      </Box> */}
      {/* <Divider mb={4} /> */}

      {/* Salary */}
      {/* <Box bg={sectionBg} borderRadius="lg" p={{ base: 2, md: 4 }} mb={4} w="full">
        <HStack justify="space-between" mb={2}>
          <Text fontWeight="bold" fontSize={{ base: 'sm', md: 'md' }}>Salary</Text>
          <IconButton icon={<MinusIcon />} size="xs" variant="ghost" aria-label="Collapse" />
        </HStack>
        <HStack spacing={2} mb={2} w="full">
          <Text fontSize={{ base: 'xs', md: 'sm' }}>{minSalary.toLocaleString()}</Text>
          <RangeSlider min={0} max={150000} value={[minSalary, maxSalary]} onChange={setSalaryRange} flex="1">
            <RangeSliderTrack>
              <RangeSliderFilledTrack />
            </RangeSliderTrack>
            <RangeSliderThumb index={0} />
            <RangeSliderThumb index={1} />
          </RangeSlider>
          <Text fontSize={{ base: 'xs', md: 'sm' }}>{maxSalary.toLocaleString()} <span style={{ fontSize: '10px' }}>BDT</span></Text>
        </HStack>
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={2} mb={2} w="full" overflow="hidden">
          {allPeriods.map(period => (
            <Button
              key={period}
              size="sm"
              colorScheme={salaryPeriod === period ? 'green' : 'gray'}
              variant={salaryPeriod === period ? 'solid' : 'outline'}
              onClick={() => setSalaryPeriod(period)}
              w="full"
              maxW="100%"
              fontSize="sm"
              borderRadius="md"
              fontWeight="semibold"
              height="36px"
              py={0}
              m={0}
            >
              {period}
            </Button>
          ))}
        </SimpleGrid>
      </Box>
      <Divider mb={4} /> */}

      {/* Category */}
      {/* <Box bg={sectionBg} borderRadius="lg" p={{ base: 2, md: 4 }} mb={4} w="full">
        <HStack justify="space-between" mb={2}>
          <Text fontWeight="bold" fontSize={{ base: 'sm', md: 'md' }}>Category</Text>
          <IconButton icon={<AddIcon />} size="xs" variant="ghost" aria-label="Expand" />
        </HStack>
      </Box>
      <Divider mb={4} /> */}

      {/* Tags */}
      {/* <Box bg={sectionBg} borderRadius="lg" p={{ base: 2, md: 4 }} mb={4} w="full">
        <HStack justify="space-between" mb={2}>
          <Text fontWeight="bold" fontSize={{ base: 'sm', md: 'md' }}>Tags</Text>
          <IconButton icon={<AddIcon />} size="xs" variant="ghost" aria-label="Expand" />
        </HStack>
      </Box>
      <Divider mb={4} /> */}

      {/* <Button colorScheme="green" w="100%" size={{ base: 'md', md: 'lg' }} mt={2} borderRadius="md" fontSize={{ base: 'sm', md: 'md' }}>
        Apply Filter
      </Button> */}
    </Box>
  );
};

export default JobOpeningFilter; 